const EXECUTIVE_MANAGER_ROLE = 'executive-manager';
const ADMIN_ROLES = {
  'all-admins': ['org-admin', 'project-admin'],
  'org-admin': ['org-admin'],
  'project-admin': ['project-admin'],
};

export const getDisplayUserName = (user) => {
  const displayName = user ? user?.full_name : 'Unknown User';

  if (user?.status === 'inactive') {
    return (
      <>
        {displayName}{' '}
        <span style={{ fontSize: '0.8em', color: 'gray', fontWeight: 'normal' }}>
          (Inactive)
        </span>
      </>
    );
  }

  return displayName;
};

export const showUserDisplayName = (userId, users) => {
  if (!userId) return null;
  const user = users?.find((u) => u?.id === userId);
  return getDisplayUserName(user || null);
};

export const renderUserOptions = (users) => {
  return users?.map((user) => (
    <option key={user?.id} value={user?.id} disabled={user?.status === 'inactive'}>
      {getDisplayUserName(user)}
    </option>
  ));
};

/** @deprecated Use useIsExecutiveManager() from hooks/useRole instead */
export const isExecutiveManager = (role) => {
  return role === EXECUTIVE_MANAGER_ROLE;
};

/** @deprecated Use useIsAdmin() from hooks/useRole instead */
export const isAdminUser = (type = 'all-admins', role) => {
  if (!role) return false;
  return (ADMIN_ROLES[type] ?? ADMIN_ROLES['all-admins']).includes(role);
};